export default __webpack_public_path__ + "static/media/icon_3.197dfecd.png";